/* Tysk katalog for locale-invoice-detail-no.js (del 1 av 2).
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('de', {
  'inv.detail.completion': 'Durchführung',
  'inv.detail.completed': 'Durchgeführt',
  'inv.detail.notCompleted': 'Nicht durchgeführt',
  'inv.detail.paymentStatus': 'Zahlungsstatus',
  'inv.detail.paid': 'Bezahlt',
  'inv.detail.remaining': 'Offen',
  'inv.detail.registeredPayments': 'Erfasste Zahlungen',
  'inv.detail.registerPayment': 'Zahlung erfassen',
  'inv.detail.settlementStatus': 'Ausgleich',
  'inv.detail.creditOffset': 'Verrechnet',
  'inv.detail.creditRefunded': 'Erstattet',
  'inv.detail.creditOpen': 'Nicht erstattet',
  'inv.detail.offsetAgainst': 'Verrechnet mit {document}',
  'inv.detail.offsetAgainstInvoice': 'Mit der Rechnung verrechnet',
  'inv.detail.refunded': 'Erstattet',
  'inv.detail.toCredit': 'Guthaben',
  'inv.detail.registeredRefunds': 'Erfasste Erstattungen',
  'inv.detail.registerRefund': 'Erstattung erfassen',
  'inv.detail.amountTitle': 'Betrag',
  'inv.detail.amountHelp': 'Netto, MwSt. und Gesamtbetrag werden aus den gespeicherten Rechnungspositionen berechnet.',
  'inv.detail.net': 'Netto',
  'inv.detail.totalAmount': 'Gesamtbetrag',
  'inv.detail.history': 'Verlauf',
  'inv.detail.action': 'Aktion',
  'inv.detail.loadingDoc': 'Dokument wird geladen...',
  'inv.detail.openedFromLink': 'Dokument über Link geöffnet',
  'inv.act.open': 'Öffnen',
  'inv.act.openHelp': 'Öffne den Entwurf in Neuer Verkauf, um ihn zu bearbeiten und zu senden.',
  'inv.act.send': 'Senden',
  'inv.act.sendAgain': 'Erneut senden',
  'inv.act.sendCreditNote': 'Gutschrift senden',
  'inv.act.sendHelp': 'Sende das Dokument per E-Mail über das Backend an den Kunden.',
  'inv.act.markDelivered': 'Als zugestellt markieren',
  'inv.act.markDeliveredHelp': 'Verwende dies, wenn das Dokument außerhalb von Plumme an den Kunden zugestellt wurde.',
  'inv.act.view.invoice': 'Rechnung ansehen',
  'inv.act.view.quote': 'Angebot ansehen',
  'inv.act.view.orderConfirmation': 'Auftragsbestätigung ansehen',
  'inv.act.view.creditNote': 'Gutschrift ansehen',
  'inv.act.viewHelp': 'Zeige eine Vorschau des Dokuments so, wie der Kunde es sieht.',
  'inv.act.copyLink': 'Link kopieren',
  'inv.act.copyLinkHelp': 'Kopiere einen teilbaren Link zum Dokument.',
  'inv.act.download': 'Herunterladen',
  'inv.act.downloadHelp': 'Lade das Dokument als PDF herunter.',
  'inv.act.packingSlip': 'Lieferschein erstellen',
  'inv.act.packingSlipHelp': 'Erstelle und lade einen Lieferschein für die Waren dieser Rechnung herunter.',
  'inv.act.copy': 'Kopie erstellen',
  'inv.toast.copyOpened': 'Die Kopie ist geöffnet — speichere sie als Entwurf oder erstelle sie',
  'inv.act.share': 'Teilen',
  'inv.act.shareHelp': 'Freigabelink kopieren, PDF herunterladen oder Lieferschein erstellen.',
  'inv.share.title': 'Dokument teilen',
  'inv.act.convertOffer': 'Erstellen',
  'inv.act.convertOfferHelp': 'Erstellt eine Rechnung oder Auftragsbestätigung als Entwurf mit dem Kunden und den Positionen aus dem Angebot.',
  'inv.convert.title': 'Aus dem Angebot erstellen',
  'inv.convert.invoice': 'Rechnung',
  'inv.convert.invoiceHelp': 'Normale Zahlungsfrist. Wird beim Erstellen gebucht.',
  'inv.convert.order': 'Auftragsbestätigung',
  'inv.convert.orderHelp': 'Bestätigt die Vereinbarung, ohne zu fakturieren. Kann später in Rechnung gestellt werden.',
  'inv.act.markAccepted': 'Als angenommen markieren',
  'inv.act.markAcceptedHelp': 'Verwende dies, wenn der Kunde das Angebot mündlich, in einem Meeting oder per E-Mail angenommen hat. Eine Annahme, die der Kunde selbst über den Angebotslink vornimmt, wird automatisch erfasst.',
  'inv.act.undoAccepted': 'Annahme entfernen',
  'inv.act.undoAcceptedHelp': 'Macht eine hier in der App erfasste Annahme rückgängig. Eine Annahme, die der Kunde selbst getätigt hat, kann nicht entfernt werden.',
  'inv.act.copyHelp': 'Erstelle eine neue Rechnung mit demselben Inhalt wie diese.',
  'inv.act.credit': 'Gutschreiben',
  'inv.act.creditHelp': 'Erstelle eine Gutschrift, die diese Rechnung ausgleicht.',
  'inv.act.delete': 'Löschen',
  'inv.act.deleteHelp': 'Diesen Entwurf löschen. Kann nicht rückgängig gemacht werden.',
  'inv.err.actionFailed': 'Die Aktion konnte nicht abgeschlossen werden.',
  'inv.err.openDoc': 'Das Dokument konnte nicht geöffnet werden.',
  'inv.err.previewPacking': 'Die Vorschau des Lieferscheins ist fehlgeschlagen.',
  'inv.err.settleNotConnected': 'Ausgleich ohne Zahlung ist nicht mit dem Backend verbunden.',
  'inv.err.settleFailed': 'Ausgleich ohne Zahlung war nicht möglich.',
  'inv.err.needEmail': 'Gib zuerst die E-Mail-Adresse des Empfängers ein.',
  'inv.err.emailCharset': 'E-Mail-Adressen dürfen kein æ, ø, å oder andere Sonderzeichen enthalten.',
  'inv.err.invalidEmail': 'Das sieht nicht wie eine gültige E-Mail-Adresse aus.',
  'inv.err.acceptNotConnected': 'Die Annahme ist nicht mit dem Backend verbunden.',
  'inv.err.acceptFailed': 'Die Annahme konnte nicht aktualisiert werden.',
  'inv.err.convertNotConnected': 'Die Umwandlung ist nicht mit dem Backend verbunden.',
  'inv.err.convertOpenFailed': 'Der Entwurf wurde erstellt, konnte aber nicht geöffnet werden.',
  'inv.err.convertFailed': 'Das Dokument konnte nicht aus dem Angebot erstellt werden.',
  'inv.err.copyOpenFailed': 'Die Kopie wurde erstellt, konnte aber nicht geöffnet werden.',
  'inv.err.deleteNotConnected': 'Das Löschen ist nicht mit dem Backend verbunden.',
  'inv.err.deleteFailed': 'Der Entwurf konnte nicht gelöscht werden.',
  'inv.toast.onlyDrafts': 'Hier können nur Entwürfe gelöscht werden',
  'inv.toast.offerAccepted': 'Das Angebot ist als angenommen markiert',
  'inv.toast.offerAcceptanceRemoved': 'Die Annahme wurde entfernt',
  'inv.toast.invoiceDraftFromOffer': 'Die Rechnung ist geöffnet — speichere sie als Entwurf oder erstelle sie',
  'inv.toast.orderDraftFromOffer': 'Die Auftragsbestätigung ist geöffnet — speichere sie als Entwurf oder erstelle sie',
  'inv.toast.draftDeleted': 'Entwurf gelöscht',
  'inv.pay.settleWithout': 'Ohne Zahlung ausgeglichen',
  'inv.pay.saveChange': 'Änderung speichern',
  'inv.pay.paidDate': 'Zahlungsdatum',
  'inv.pay.datePh': 'tt.mm.jjjj',
  'inv.pay.registerPaymentTitle': 'Zahlung erfassen',
  'inv.pay.editPaymentTitle': 'Zahlung bearbeiten',
  'inv.pay.registerRefundTitle': 'Erstattung erfassen',
  'inv.pay.editRefundTitle': 'Erstattung bearbeiten',
  'inv.pay.paidFrom': 'Bezahlt von',
  'inv.pay.refundDate': 'Erstattungsdatum',
  'inv.pay.refundAmount': 'Erstatteter Betrag',
  'inv.pay.remainingNote': 'Offener Betrag auf der Rechnung: {amount}. Du kannst eine Teilzahlung erfassen.',
  'inv.pay.refundNote': 'Der Kunde hat ein Guthaben von {amount} aus der Gutschrift. Du kannst eine Teilerstattung erfassen.',
  'inv.pay.refundHelp': 'Die Gutschrift storniert den Verkauf in jedem Fall. Erfasse eine Erstattung nur, wenn der Kunde tatsächlich Geld zurückbekommt.',
  'inv.pay.fee': 'Bank- und Kartengebühr',
  'inv.pay.feeAccount': 'Gebührenkonto',
  'inv.pay.bankAmountIn': 'Tatsächlicher Zahlungseingang auf der Bank: {amount}',
  'inv.pay.bankAmountOut': 'Tatsächlicher Zahlungsausgang von der Bank: {amount}',
  'inv.detail.offsetCustomerCredit': 'Kundenguthaben verrechnen',
  'inv.detail.customerCreditOffset': 'Kundenguthaben verrechnet',
  'inv.detail.customerCreditAllocated': 'Mit anderer Rechnung verrechnet',
  'inv.detail.relatedRefund': 'Über die zugehörige Gutschrift erstattet',
  'inv.toast.customerCreditOffset': 'Das Kundenguthaben wurde mit der Rechnung verrechnet',
  'inv.err.noCustomerCredit': 'Keine verfügbare Kundengutschrift gefunden.',
  'inv.err.customerCreditOffsetFailed': 'Das Kundenguthaben konnte nicht verrechnet werden.',
  'cust.ledger.creditOffset': 'Kundenguthaben verrechnet',
  'inv.toast.paymentRegistered': 'Zahlungseingang erfasst',
  'inv.toast.paymentUpdated': 'Zahlung aktualisiert',
  'inv.toast.refundRegistered': 'Erstattung erfasst',
  'inv.toast.refundUpdated': 'Erstattung aktualisiert',
  'inv.err.paymentFailed': 'Der Zahlungseingang konnte nicht erfasst werden.',
  'inv.err.paymentUpdateFailed': 'Die Zahlung konnte nicht aktualisiert werden.',
  'inv.err.refundFailed': 'Die Erstattung konnte nicht erfasst werden.',
  'inv.err.refundUpdateFailed': 'Die Erstattung konnte nicht aktualisiert werden.',
  'inv.del.confirm': 'Ja, Entwurf löschen',
  'inv.del.body': 'Möchtest du diesen Entwurf für {customer} wirklich löschen? Das kann nicht rückgängig gemacht werden.',
  'inv.send.body': '{document} über {amount} wird als PDF per E-Mail an {customer} gesendet.',
  'inv.send.resendNote': ' Dies ist ein erneuter Versand eines bereits gesendeten Dokuments.',
  'inv.credit.continue': 'Zur Gutschrift',
  'inv.credit.intro': 'Eine Gutschrift gleicht die Rechnung für {customer} aus. Wähle, ob du die ganze Rechnung oder nur einen Teil davon gutschreiben möchtest.',
  'inv.credit.full': 'Vollständige Gutschrift',
  'inv.credit.partial': 'Teilgutschrift',
  'inv.credit.line': 'Position',
  'inv.credit.count': 'Menge',
  'inv.credit.credited': 'Gutzuschreiben',
  'inv.credit.total': 'Betrag der Gutschrift',
  'inv.credit.breakdown': 'Netto {net} · MwSt. {vat}',
  'inv.credit.partialSuffix': ' · Teilgutschrift',
  'inv.delivery.rowFailed': 'Nicht zugestellt',
  'inv.delivery.bannerTitle': '{n} Dokumente haben den Empfänger nicht erreicht',
  'inv.delivery.bannerBody': 'Die E-Mail wurde abgelehnt oder kam zurück: {documents}. Öffne das Dokument, korrigiere die E-Mail-Adresse beim Kunden und sende es erneut.',
  'inv.credit.rest': 'Rest gutschreiben',
  'inv.credit.alreadyCredited': 'Bereits gutgeschrieben: {amount}. Du kannst nur den verbleibenden Rest gutschreiben.',
  'inv.credit.closedLines': '{n} Positionen sind vollständig gutgeschrieben und werden nicht angezeigt.',
  'inv.credit.lineAlready': '{amount} gutgeschrieben',
  'inv.credit.hasPayments': 'Die Rechnung hat erfasste Zahlungen. Die Gutschrift gleicht den offenen Betrag aus; eine eventuelle Erstattung wird separat erfasst.',
  'inv.credit.date': 'Gutschriftsdatum',
  'inv.credit.dateHint': 'Das Datum bestimmt, in welchem Buchhaltungs- und MwSt.-Zeitraum die Gutschrift gebucht wird.',
  'inv.credit.dateBeforeInvoice': 'Das Gutschriftdatum darf nicht vor dem Rechnungsdatum liegen.',
  'inv.credit.invalidDate': 'Wähle ein gültiges Gutschriftsdatum.',
  'inv.credit.paidConfirmTitle': 'Die Rechnung ist bezahlt',
  'inv.credit.paidConfirmBody': 'Für diese Rechnung sind Zahlungen über {amount} erfasst. Die Gutschrift storniert den Verkauf, eine eventuelle Rückerstattung wird jedoch separat erfasst. Möchtest du fortfahren?',
  'inv.credit.paidConfirmContinue': 'Ja, Gutschrift fortsetzen',
  'inv.bulk.creditDateHint': 'Für alle Gutschriften wird dasselbe Datum verwendet. Das Datum bestimmt den Buchungs- und MwSt.-Zeitraum.',
  'inv.bulk.creditDateBeforeInvoices': 'Das Datum darf nicht vor dem sp?testen Rechnungsdatum in der Auswahl liegen.',
  'inv.bulk.creditPaidConfirmBody': '{n} der ausgewählten Rechnungen haben erfasste Zahlungen. Die Gutschriften stornieren die Verkäufe, eventuelle Rückerstattungen werden jedoch separat erfasst. Möchtest du fortfahren?',
  'inv.history.creditPartial': 'Teilweise gutgeschrieben {amount} · Gutschrift {document}',
  'inv.history.creditFull': 'Gutgeschrieben {amount} · Gutschrift {document}',
  'inv.history.creditDraft': 'Gutschrift {document} als Entwurf erstellt · {amount}',
  'inv.history.creditNoNumber': 'ohne Nummer',
  'inv.toast.creditOpened': 'Die Gutschrift für {document} ist geöffnet — gib den Grund ein und erstelle sie',
  'inv.toast.partialCreditOpened': 'Die Teilgutschrift für {document} ist geöffnet — gib den Grund ein und erstelle sie',
  'inv.bulk.selectAll': 'Alle angezeigten auswählen',
  'inv.bulk.selectRow': 'Dokument auswählen. Umschalt-Klick wählt den Bereich aus.',
  'inv.bulk.selectDocument': 'Dokument auswählen',
  'inv.bulk.selectDocuments': 'Dokumente auswählen',
  'inv.bulk.selectedCount': '{n} ausgewählt',
  'inv.bulk.shownCount': '{n} in der Liste angezeigt',
  'inv.bulk.reset': 'Zurücksetzen',
  'inv.bulk.deliver': 'Als zugestellt markieren',
  'inv.bulk.resend': 'Erneut senden',
  'inv.bulk.reminder': 'Mahnung',
  'inv.bulk.credit': 'Gutschreiben',
  'inv.bulk.issue': 'Erstellen und senden',
  'inv.bulk.delete': 'Löschen',
  'inv.bulk.processing': 'Wird verarbeitet ...',
  'inv.bulk.document': 'Dokument',
  'inv.bulk.amount': 'Betrag',
  'inv.bulk.more': '+ {n} weitere',
  'inv.bulk.noEmail': 'keine E-Mail',
  'inv.bulk.newDueDate': 'neue Frist {date}',
  'inv.bulk.reminderType': 'Art',
  'inv.bulk.reminderNotice': 'Zahlungserinnerung',
  'inv.bulk.reminderDunning': 'Mahnung',
  'inv.bulk.reminderDueDays': 'Tage bis zur neuen Frist',
  'inv.bulk.reminderFee': 'Mahngebühr',
  'inv.bulk.reminderFeeLocked': 'Eine Gebühr kann nur bei einer Mahnung erhoben werden.',
  'inv.bulk.delivery': 'Senden als',
  'inv.bulk.deliveryPdf': 'PDF-Anhang',
  'inv.bulk.deliveryLink': 'Link',
  'inv.bulk.comment': 'Nachricht an den Kunden',
  'inv.bulk.commentHint': 'Erscheint in der E-Mail neben der Betragsübersicht. Die Rechnung selbst wird nicht geändert.',
  'inv.bulk.commentPh': 'Zum Beispiel: Wir sehen, dass die Rechnung noch offen ist. Melde dich, wenn etwas unklar ist.',
  'inv.comment.label': 'Nachricht an den Kunden',
  'inv.comment.hint': 'Optionaler Text, der diesem Versand beigefügt wird.',
  'inv.comment.placeholder': 'Nachricht schreiben ...',
  'inv.comment.useSaved': 'Nachricht verwenden',
  'inv.comment.save': 'Nachricht speichern',
  'inv.comment.update': 'Nachricht aktualisieren',
  'inv.comment.saveTitle': 'Nachricht speichern',
  'inv.comment.updateTitle': 'Nachricht aktualisieren',
  'inv.comment.saveAsNew': 'Als neu speichern',
  'inv.comment.savedTitle': 'Gespeicherte Nachrichten',
  'inv.comment.name': 'Name der Nachricht',
  'inv.comment.namePh': 'Zum Beispiel: Freundliche Erinnerung',
  'inv.comment.nameHint': 'Unter diesem Namen findest du die Nachricht in der Liste wieder.',
  'inv.comment.needName': 'Gib der Nachricht zuerst einen Namen',
  'inv.comment.empty': 'Du hast noch keine gespeicherten Nachrichten.',
  'inv.comment.use': 'Verwenden',
  'inv.comment.saved': 'Nachricht gespeichert',
  'inv.comment.updated': 'Nachricht aktualisiert',
  'inv.comment.deleted': 'Nachricht gelöscht',
  'inv.comment.saveFailed': 'Die Nachricht konnte nicht gespeichert werden.',
  'inv.comment.deleteFailed': 'Die Nachricht konnte nicht gelöscht werden.',
  'inv.comment.notConnected': 'Nachrichten sind nicht mit dem Backend verbunden.',
  'inv.bulk.mode': 'Was soll passieren',
  'inv.bulk.mode.draft': 'Als Entwurf speichern',
  'inv.bulk.mode.send': 'Erstellen und senden',
  'inv.bulk.mode.create': 'Nur erstellen',
  'inv.bulk.mode.hint.credit': 'Die Gutschriften werden im Tab „Entwürfe“ abgelegt. Nichts wird gebucht oder gesendet, bevor du sie erstellst.',
  'inv.bulk.mode.hint.creditSend': 'Die Gutschriften werden sofort gebucht und an die Kunden gesendet. Dies kann nicht rückgängig gemacht werden.',
  'inv.bulk.mode.hint.issueSend': 'Die Entwürfe werden mit Dokumentnummer gebucht und per E-Mail an die Kunden gesendet.',
  'inv.bulk.mode.hint.issue': 'Die Entwürfe werden mit Dokumentnummer gebucht, aber es wird keine E-Mail versendet.',
  'inv.bulk.creditReasonOptional': 'Optional, solange die Gutschrift ein Entwurf ist. Der Grund muss vorhanden sein, bevor sie gebucht werden kann.',
  'inv.bulk.creditReasonRequired': 'Pflichtfeld. Der Grund steht auf der Gutschrift und dokumentiert, warum der Verkauf storniert wurde.',
  'inv.bulk.title.deliver': 'Ausgewählte Dokumente als zugestellt markieren',
  'inv.bulk.title.send': 'Ausgewählte Dokumente erneut senden',
  'inv.bulk.title.reminder': 'Mahnung oder Zahlungserinnerung senden',
  'inv.bulk.title.credit': 'Ausgewählte Rechnungen gutschreiben',
  'inv.bulk.title.issue': 'Ausgewählte Entwürfe erstellen',
  'inv.bulk.title.delete': 'Ausgewählte Entwürfe löschen',
  'inv.bulk.confirm.deliver': 'Als zugestellt markieren',
  'inv.bulk.confirm.send': 'Erneut senden',
  'inv.bulk.confirm.reminder': 'Nachfassung senden',
  'inv.bulk.confirm.credit': 'Gutschriften erstellen',
  'inv.bulk.confirm.creditSend': 'Gutschriften erstellen und senden',
  'inv.bulk.confirm.issue': 'Dokumente erstellen',
  'inv.bulk.confirm.issueSend': 'Erstellen und senden',
  'inv.bulk.confirm.delete': 'Ja, Entwürfe löschen',
  'inv.bulk.body.deliver': 'Dokumente, die als außerhalb von Plumme zugestellt markiert werden: {n}. Es wird keine E-Mail gesendet, und Buchung und Zahlung bleiben unverändert.',
  'inv.bulk.body.send': '{n} Dokumente werden an die beim Kunden hinterlegte E-Mail-Adresse gesendet.',
  'inv.bulk.body.reminder': '{n} überfällige oder unbezahlte Rechnungen werden nachverfolgt. Die Originalrechnung wird nicht erneut gebucht.',
  'inv.bulk.body.credit': '{n} Rechnungen werden über den Restbetrag gutgeschrieben, eine Gutschrift pro Rechnung. Bereits gutgeschriebene Zeilen werden nicht erneut berücksichtigt.',
  'inv.bulk.body.creditSend': '{n} Rechnungen werden über den Restbetrag gutgeschrieben. Die Gutschriften werden sofort erstellt, gebucht und an den Kunden gesendet — ohne Umweg über Entwürfe.',
  'inv.bulk.body.issue': '{n} Entwürfe werden erstellt und gebucht und erhalten eine Dokumentnummer.',
  'inv.bulk.body.issueSend': '{n} Entwürfe werden erstellt, gebucht und per E-Mail an den Kunden gesendet.',
  'inv.bulk.body.delete': '{n} Entwürfe werden gelöscht. Entwürfe sind nicht gebucht, aber das Löschen kann nicht rückgängig gemacht werden.',
  'inv.bulk.skip.deliver': 'Ausgewählte Zeilen, die Entwürfe, bereits zugestellt oder gesendet sind und übersprungen werden: {n}.',
  'inv.bulk.skip.send': '{n} ausgewählte Dokumente haben keine E-Mail und werden übersprungen.',
  'inv.bulk.skip.reminder': '{n} ausgewählte Zeilen können hier nicht gemahnt werden oder haben keine E-Mail.',
  'inv.bulk.skip.credit': '{n} ausgewählte Zeilen können hier nicht gutgeschrieben werden.',
  'inv.bulk.skip.issue': '{n} ausgewählten Entwürfen fehlen Kunde oder Zeilen, sie können hier nicht erstellt werden.',
  'inv.bulk.skip.noEmail': '{n} der Dokumente haben keine E-Mail-Adresse. Sie werden erstellt und gebucht, aber nicht gesendet.',
  'inv.bulk.skip.delete': '{n} ausgewählte Zeilen sind keine Entwürfe und werden nicht gelöscht.',
  'inv.bulk.toast.delivered': 'Als zugestellt markierte Dokumente: {n}',
  'inv.bulk.toast.sent': '{n} Dokumente gesendet',
  'inv.bulk.toast.reminded': '{n} Zahlungserinnerungen gesendet',
  'inv.bulk.toast.dunned': '{n} Mahnungen gesendet',
  'inv.bulk.toast.credited': '{n} Gutschriften als Entwurf erstellt',
  'inv.bulk.toast.creditedSent': '{n} Gutschriften erstellt und gesendet',
  'inv.bulk.toast.issued': '{n} Dokumente erstellt',
  'inv.bulk.toast.issuedSent': '{n} Dokumente erstellt und gesendet',
  'inv.bulk.toast.deleted': '{n} Entwürfe gelöscht',
  'inv.bulk.toast.notSentSuffix': ', {n} ohne E-Mail erstellt',
  'inv.bulk.toast.failedSuffix': ', {n} fehlgeschlagen',
  'inv.bulk.err.failed': 'Die Massenaktion konnte nicht abgeschlossen werden.',
  'inv.bulk.err.deliverNotConnected': '„Als zugestellt markieren“ ist nicht mit dem Backend verbunden.',
  'inv.bulk.err.sendNotConnected': 'Der Versand ist nicht mit dem Backend verbunden.',
  'inv.bulk.err.creditNotConnected': 'Die Gutschrift ist nicht mit dem Backend verbunden.',
  'inv.bulk.err.issueNotConnected': 'Das Erstellen von Entwürfen ist nicht mit dem Backend verbunden.',
  'inv.packing.preview': 'Vorschau',
  'inv.packing.download': 'Lieferschein herunterladen',
  'inv.packing.invoiceDate': 'Rechnungsdatum',
  'inv.pay.account.1920': 'Geschäftskonto - 1920',
  'inv.pay.account.2063': 'Privat - 2063',
  'inv.pay.account.1900': 'Bargeld - 1900',
  'inv.report.customer': 'Kunde',
  'inv.report.product': 'Produkt',
  'inv.report.salesCount': 'Anzahl Verkäufe',
  'inv.report.count': 'Menge',
  'inv.report.exVat': 'Ohne MwSt.',
  'inv.report.share': 'Anteil am Gesamt',
  'inv.report.noSales': 'Keine Verkäufe im Zeitraum.',
  'inv.report.noProducts': 'Im Zeitraum wurden keine Produkte verkauft.',
  'inv.report.openCustomer': '{name} in Kunden öffnen',
  'inv.report.totalCustomers': '({n} Kunden)',
  'inv.report.totalCustomer': '({n} Kunde)',
  'inv.report.totalProducts': '({n} Produkte)',
  'inv.report.totalProduct': '({n} Produkt)',
  'inv.report.total': 'Gesamt',
  'inv.report.tile.sales': 'Verkäufe',
  'inv.report.tile.activeCustomers': 'Aktive Kunden',
  'inv.report.tile.newCustomers': 'Neue Kunden',
  'inv.report.tile.totalCustomers': 'Kunden insgesamt',
  'inv.report.tile.customerRevenue': 'Kundenumsatz',
  'inv.report.tile.totalRevenue': 'Gesamtumsatz',
  'inv.report.tile.soldProducts': 'Verkaufte Produkte',
  'inv.report.tile.productTypes': 'Produkttypen',
  'inv.report.tile.productRevenue': 'Produktumsatz',
  'inv.report.unknownCustomer': 'Unbekannter Kunde',
  'inv.report.unspecifiedSale': 'Nicht spezifizierter Verkauf',
  'inv.report.customerSummaryOne': 'Im Zeitraum wurden {sales} Verkäufe an {customers} Kunden erfasst. Verkäufe an Kunden beliefen sich auf {amount}.',
  'inv.report.customerSummaryMany': 'Im Zeitraum wurden {sales} Verkäufe an {customers} Kunden erfasst. Verkäufe an Kunden beliefen sich auf {amount}.',
  'inv.report.productSummaryOne': 'Im Zeitraum wurden {count} Produkte/Zeilen von {types} Produkttyp verkauft, insgesamt {amount}.',
  'inv.report.productSummaryMany': 'Im Zeitraum wurden {count} Produkte/Zeilen von {types} Produkttypen verkauft, insgesamt {amount}.',
  'inv.fallback.noCustomer': 'Ohne Kunde',
  'inv.fallback.line': 'Zeile {n}',
  'inv.credit.fallbackDescription': 'Verkauf gemäß {document}',
  'inv.credit.dialogTitle': 'Rechnung {number} gutschreiben',
  'inv.detail.validUntil': 'Gültig bis',
  'inv.detail.dueDate': 'Fällig',
  'inv.detail.partiallyPaid': 'Teilweise bezahlt',
  'inv.detail.unpaid': 'Nicht bezahlt',
  'inv.detail.acceptedManual': 'Angenommen {date} · in der App erfasst',
  'inv.detail.acceptedCustomer': 'Angenommen {date} · vom Kunden',
  'inv.detail.orderSentAt': 'Auftragsbestätigung gesendet {date}',
  'inv.detail.paymentFeeBank': 'Gebühr {fee} · Bank {bank}',
  'inv.detail.deliveryFailureHelp': 'Das Dokument ist gespeichert, aber der Empfänger hat es nicht erhalten. Korrigiere die Adresse beim Kunden und sende es erneut.',
  'inv.detail.timelineHelp': 'Zeitleiste aus gespeichertem Dokumentstatus und Zahlungen.',
  'inv.history.offerAcceptedManual': 'Angebot als angenommen markiert (in der App erfasst)',
  'inv.history.offerAcceptedCustomer': 'Angebot vom Kunden angenommen',
  'inv.history.orderSent': 'Auftragsbestätigung gesendet',
  'inv.history.documentSentTo': '{document} gesendet an {recipient}',
  'inv.history.deliveredExternally': 'Außerhalb von Plumme zugestellt',
  'inv.history.documentCreated': 'Dokument erstellt',
  'inv.packing.intro': 'Lege das Versanddatum fest. Das heutige Datum ist voreingestellt.',
  'inv.packing.shippingDate': 'Versanddatum',
  'inv.packing.contents': 'Der Lieferschein zeigt Beschreibungen und Mengen aus den Rechnungszeilen. Preise, MwSt. und Zahlungsinformationen werden nicht angezeigt.',
  'inv.packing.title': 'Lieferschein {number}',
  'inv.err.pdfPreviewNotConnected': 'Die PDF-Vorschau ist nicht mit dem Backend verbunden.',
  'inv.err.packingNotConnected': 'Der Lieferschein ist nicht mit dem Backend verbunden.',
  'inv.err.packingDownloadFailed': 'Der Lieferschein konnte nicht heruntergeladen werden.',
  'inv.err.paymentNotConnected': 'Zahlungseingänge sind nicht mit dem Backend verbunden.',
  'inv.err.paymentEditNotConnected': 'Das Bearbeiten von Zahlungen ist nicht mit dem Backend verbunden.',
  'inv.err.sendNotConnected': 'Das Senden ist nicht mit dem Backend verbunden.',
  'inv.err.sendFailed': 'Das Dokument konnte nicht gesendet werden.',
  'inv.err.deliverNotConnected': 'Das Markieren als zugestellt ist nicht mit dem Backend verbunden.',
  'inv.err.deliverFailed': 'Das Dokument konnte nicht als zugestellt markiert werden.',
  'inv.err.linkNotConnected': 'Der Rechnungslink ist nicht mit dem Backend verbunden.',
  'inv.err.linkFailed': 'Der Rechnungslink konnte nicht abgerufen werden.',
  'inv.err.downloadNotConnected': 'Der PDF-Download ist nicht mit dem Backend verbunden.',
  'inv.err.downloadFailed': 'Das Dokument konnte nicht heruntergeladen werden.',
  'inv.err.copyNotConnected': 'Das Kopieren ist nicht mit dem Backend verbunden.',
  'inv.err.copyFailed': 'Es konnte keine Kopie des Dokuments erstellt werden.',
  'inv.err.archiveNotConnected': 'Das Archivieren ist nicht mit dem Backend verbunden.',
  'inv.err.archiveFailed': 'Der Archivstatus konnte nicht aktualisiert werden.',
  'inv.err.creditNotConnected': 'Gutschriften sind nicht mit dem Backend verbunden.',
  'inv.err.creditFailed': 'Die Gutschrift konnte nicht erstellt werden.',
  'inv.toast.packingDownloading': 'Lieferschein wird heruntergeladen',
  'inv.toast.settledWithoutPayment': 'Die Rechnung ist ohne Zahlung ausgeglichen',
  'inv.toast.sendingBackground': '{document} wird im Hintergrund gesendet',
  'inv.toast.documentSent': '{document} gesendet',
  'inv.toast.deliveredExternally': 'Das Dokument ist als zugestellt markiert',
  'inv.toast.readyNoEmail': 'Das Dokument ist vorbereitet, aber es wurde keine E-Mail gesendet.',
  'inv.toast.linkCopied': 'Link zu {number} kopiert',
  'inv.toast.documentDownloading': 'Das Dokument wird heruntergeladen',
  'inv.toast.archiveRestored': 'Aus dem Archiv geholt',
  'inv.toast.archived': 'Archiviert',
  'inv.toast.creditCreated': '{document} für {number} erstellt',
  'inv.act.unarchive': 'Aus dem Archiv holen',
  'inv.act.archive': 'Archivieren',
  'inv.act.archiveHelp': 'Verschiebe das Angebot oder die Auftragsbestätigung ins Archiv oder hole es wieder heraus.',
  'inv.convert.alreadyTitle': 'Das Angebot wurde bereits umgewandelt in:',
  'inv.convert.duplicateWarning': 'Wenn du ein weiteres erstellst, musst du selbst darauf achten, dass dem Kunden dieselbe Arbeit nicht doppelt in Rechnung gestellt wird.',
  'inv.convert.footerHelp': 'Beide werden als Entwurf mit dem Kunden und den Zeilen aus dem Angebot erstellt und im Verkaufsablauf geöffnet.',
  'inv.send.title': '{document} {number} senden',
  'inv.deliver.title': 'Als zugestellt markieren',
  'inv.deliver.body': 'Verwende dies, wenn das Dokument dem Kunden bereits auf anderem Weg zugestellt wurde. Plumme sendet keine E-Mail. Buchung, MwSt. und Zahlungsstatus bleiben unverändert, aber Erinnerungen an ein nicht gesendetes Dokument werden beendet.',
  'inv.delivery.external': 'Außerhalb von Plumme zugestellt',
  'inv.more': 'Mehr',
  'inv.err.offerAlreadyConverted': 'Das Angebot wurde bereits in diesen Dokumenttyp umgewandelt.',
  'sale.totalDiscount': 'Gesamtrabatt',
  'sale.totalDiscountHelp': 'Wird anteilig auf alle Produktzeilen verteilt und mit nachvollziehbarer Verteilung gespeichert.',
  'sale.det.currency': 'Dokumentwährung',
  'sale.det.exchangeRate': 'Kurs zu {currency}',
  'sale.det.exchangeRateDate': 'Kursdatum',
  'sale.det.exchangeRateSource': 'Kursquelle',
  'sale.det.exchangeRateSourcePh': 'Zum Beispiel Norges Bank oder vereinbarter Kurs',
  'sale.create.needCurrencyEvidence': 'Gib einen positiven Kurs, ein Kursdatum und eine Quelle an, bevor die Rechnung erstellt wird.',
  'sale.preview.accountingAmount': 'Buchungsbetrag: {amount} {currency} · Kurs {rate}',
  'sale.preview.vatAccountingAmount': 'MwSt. in {currency}: {amount}',
});
